import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';

@Component({
    selector: 'app-searchbar[value][id]',
    templateUrl: './searchbar.component.html',
    styleUrls: ['./searchbar.component.scss'],
    imports: [InputTextModule, FormsModule, TranslateModule, ButtonModule],
    standalone: true,
})
export class SearchbarComponent implements OnChanges {
    @Input() value: string = '';
    @Input() id!: string;
    @Input() searchPlaceholder!: string;
    @Input() maxLength!: number;
    @Input() disabled: boolean = false;

    @Output() onSearch: EventEmitter<string> = new EventEmitter<string>();
    @Output() onSearchWithDebounce: EventEmitter<string> = new EventEmitter<string>();

    controlValue: string = '';
    searchbarFocus: boolean = false;

    ngOnChanges(): void {
        if (this.controlValue === this.value) {
            return;
        }
        this.controlValue = this.value;
    }

    search(): void {
        this.onSearch.emit(this.controlValue);
    }

    searchWithDebounce(): void {
        this.onSearchWithDebounce.emit(this.controlValue);
    }

    clear(event: any): void {
        if (this.disabled) {
            return;
        }

        event.stopPropagation();
        this.controlValue = '';
        this.search();
        this.searchWithDebounce();
    }

    checkSearchInputValue() {
        if (this.controlValue === '') {
            this.onSearch.emit(this.controlValue);
        }
    }
}
